// extracted by mini-css-extract-plugin
export var addButton = "_fl-0";
export var border = "_fl-8";
export var check = "_fl-h";
export var danger = "_fl-6";
export var dropdownContainer = "_fl-1";
export var editModalBody = "_fl-j";
export var footerContainer = "_fl-i";
export var fullWidth = "_fl-a";
export var hide = "_fl-9";
export var icon = "_fl-3";
export var input = "_fl-7";
export var inputFlex = "_fl-b";
export var inputWrapper = "_fl-c";
export var manualFocus = "_fl-5";
export var optionButton = "_fl-4";
export var pillWrapper = "_fl-e";
export var pointer = "_fl-2";
export var showOverflow = "_fl-f";
export var tagsFlex = "_fl-d";
export var xButton = "_fl-g";